export default "__VITE_ASSET__DKEC0233__"